import React from "react";
// import * as Sentry from "@sentry/browser";
import ReactDOM from "react-dom";
import App from "./App";
import registerServiceWorker from "./registerServiceWorker";

// Sentry.init({
//   dsn: "https://4d7a0f55e8c646938744f579e06c5c74@sentry.io/1485149"
// });

ReactDOM.render(<App />, document.getElementById("root"));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js